import { conditions, responseValidator } from "helpers";
import { ConditionName, IPreFactor } from "interfaces";
import { useEffect } from "react";
import { handlePaymentRequest, useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'
import { API, apiCaller } from "../../../../../services";
import Popover from "../popover/popover";
import { useState } from "react";
import IMAGES from "../../../../../images/importImages";
import Image from "next/image";

const PreFactorPopover = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [preFactor, setPreFactor] = useState<IPreFactor>({
        active_duration:0,
        id:0,
        max_usage:0,
        price:0,
    });

    const tax = preFactor.price * 0.09;

    const { preFactorPopover } = useAppSelector(({ popovers: { preFactorPopover } }) => ({ preFactorPopover }), shallowEqual);

    let customHeader = <></>;

    useEffect(() => {
        if(conditions(ConditionName.showPreFactorPopover)) {
            (async() => {
                const { data, status } = await apiCaller({ url: API().cinemahamrah.voucherPackages() });
                if (responseValidator(status)) {
                    setPreFactor(data.results[0]);
                }
            })()
        }
    }, [preFactorPopover])

    if(conditions(ConditionName.showPreFactorPopover)) {
        customHeader = (
            <div className="pl-flex pl-items-center pl-gap-2 pl-pb-[18px] pl-px-4 pl-py-6">
                <Image src={conditions(ConditionName.isDarkMode) ? IMAGES.textDocumentWhite : IMAGES.textDocumentBlack} width={24} height={24} />
                <p className="pl-text-[18px] pl-font-bold pl-text-z-gray-700 dark:pl-text-dark-5">جزئیات خرید بسته سینما همراه</p>
            </div>
        )
    }

    return (
        <Popover 
            status={conditions(ConditionName.showPreFactorPopover)}
            onClose={() => {}}
            type="modal"
            isHeader={true}
            customHeader={customHeader}
            isBlurBackground={true}
        >
            <div className="pl-px-4 pl-py-6">
                <p className="pl-text-[14px] pl-font-medium pl-text-z-gray-700 dark:pl-text-dark-5">کاربر گرامی، برای تماشای فیلم سینمایی، نیاز به خرید بلیط سینما همراه می‌باشد، شما می‌توانید از طریق گزینه پرداخت آنلاین نسبت به خرید بلیط سینماهمراه اقدام نمایید.</p>
                <div className="pl-flex pl-flex-col pl-gap-4 pl-border pl-border-z-secondary-100 dark:pl-border-dark-3 pl-rounded-[16px] pl-max-w-[412px] pl-mx-auto pl-mt-4 pl-mb-6 pl-px-8 pl-py-6 pl-text-[14px] pl-font-normal pl-text-z-secondary-600 dark:pl-text-z-secondary-50">
                    <p className="pl-flex pl-justify-between pl-items-center">
                        <span>تعداد استفاده</span>
                        <p>
                            <span className="pl-text-z-gray-700 dark:pl-text-white">{preFactor.max_usage}</span>
                            <span className="pl-text-z-secondary-500 dark:pl-text-secondary pl-mr-1">مرتبه</span>
                        </p>
                    </p>
                    <p className="pl-flex pl-justify-between pl-items-center">
                        <span>زمان اعتبار</span>
                        <p>
                            <span className="pl-text-z-gray-700 dark:pl-text-white">{preFactor.active_duration}</span>
                            <span className="pl-text-z-secondary-500 dark:pl-text-secondary pl-mr-1">روز</span>
                        </p>
                    </p>
                    <p className="pl-flex pl-justify-between pl-items-center">
                        <span>هزینه بسته</span>
                        <p>
                            <span className="pl-text-z-gray-700 dark:pl-text-white">{preFactor.price.toLocaleString()}</span>
                            <span className="pl-text-z-secondary-500 dark:pl-text-secondary pl-mr-1">تومان</span>
                        </p>
                    </p>
                    <p className="pl-flex pl-justify-between pl-items-center">
                        <span>مالیات بر ارزش افزوده (%9)</span>
                        <p>
                            <span className="pl-text-z-gray-700 dark:pl-text-white">{tax.toLocaleString()}</span>
                            <span className="pl-text-z-secondary-500 dark:pl-text-secondary pl-mr-1">تومان</span>
                        </p>
                    </p>
                    <hr />
                    <p className="pl-flex pl-justify-between pl-items-center pl-font-bold">
                        <span className="pl-text-z-secondary-600 dark:pl-text-z-secondary-50">مبلغ قابل پرداخت</span>
                        <span className="pl-text-z-gray-700 dark:pl-text-white">{(preFactor.price + tax).toLocaleString()} تومان</span>
                    </p>
                </div>
                <button 
                    disabled={isLoading} 
                    className="pl-bg-main-light hover:pl-bg-main-700 disabled:pl-bg-main disabled:pl-opacity-50 pl-transition-colors pl-duration-300 pl-px-6 pl-py-4 pl-text-white pl-text-[15px] pl-font-medium pl-w-full pl-rounded-[8px]" 
                    onClick={() => handlePaymentRequest(preFactor.id, setIsLoading)}
                >
                    {isLoading ? "در حال اتصال به درگاه پرداخت" : "پرداخت آنلاین"}
                </button>
            </div>
        </Popover>
    )
}

export default PreFactorPopover;